import { type Notification } from "@prisma/client";
import type { ToastContentProps } from "react-toastify";
import { NotificationItem } from "./NotificationItem";

type NotificationToastProps = ToastContentProps<Notification>;

export function NotificationToast({ data }: NotificationToastProps) {
  return <NotificationItem notification={data} />;
}
